import { Injectable } from "@angular/core";
import { UseCase } from "../../base";
import { PlansRepository } from "../../repositories";
import { Observable } from "rxjs";
import { AssignLocationsGroupsToPlanRequest } from "../../domain/requests/plans/assign-location-to-plan-request";

@Injectable({ providedIn: 'root' })
export class AssignLocationsGroupsToPlanUsecase implements UseCase<AssignLocationsGroupsToPlanRequest, boolean> {

  constructor(private readonly planRepository: PlansRepository) {
  }

  execute(params: AssignLocationsGroupsToPlanRequest): Observable<boolean> {
    return this.planRepository.assignLocationsGroupsToPlan(params);
  }
}
